export default __webpack_public_path__ + "static/ndla-logo-b6be2f0a6c7e2a571b7f67b957218928.png";